/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from "react";

import { Billing } from "./billing";
import { History } from "./history";
import { Preferences } from "./preferences";

const views = [
    'Delivery Information',
    'Preferences',
    'History'
];

let lastActiveView = views[0];

const CustomerInfo = ({ customer, onUpdate }) => {
    const [currentView, setCurrentView] = useState(lastActiveView);

    const handleClick = (view) => {
        setCurrentView(view);
        lastActiveView = view;
    }

    const Component = () => {
        if (currentView === views[0]) {
            return <Billing customer={customer} onUpdate={onUpdate} />
        }

        if (currentView === views[1]) {
            return <Preferences customer={customer} onUpdate={onUpdate} />
        }

        if (currentView === views[2]) {
            return <History customer={customer} />
        }

        return null;
    }

    return (
        <div className="container">

            <div className="is-flex is-justify-content-space-between is-align-content-baseline">
                <nav className="breadcrumb" aria-label="breadcrumbs">
                    <ul>
                        {views.map((view) => (
                            <li className={view === currentView ? 'is-active' : ''} key={view}>
                                <a onClick={() => handleClick(view)}>{view}</a>
                            </li>
                        ))}
                    </ul>
                </nav>
            </div>

            <div className="mt-4">
                <Component />
            </div>
        </div >
    );
};

export { CustomerInfo };
